<div *ngIf="!appMain.isMobile" class="flex align-items-center justify-content-end mb-3">
    <p-selectButton [options]="viewOptions" [(ngModel)]="selectedView" optionLabel="label" optionValue="value"></p-selectButton>
</div>

<div [ngClass]="{'hidden': selectedView() !== 'table'}">
    <p-card>
        <p-table #dt [value]="rapportSST" [rows]="50" [rowsPerPageOptions]="[10,25,50,100,500]" paginator [totalRecords]="totalRecords"
            autoLayout="true" [rowHover]="true" sortMode="multiple" [multiSortMeta]="sortMeta" dataKey="rapportSstId" responsiveLayout="stack" [loading]="loading" lazy (onLazyLoad)="chargerRapportSST($event)">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between flex-wrap gap-3">
                    <div class="flex align-items-center gap-3 flex-wrap">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" autofocus (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="Search..." />
                        </span>
                        <button pButton pRipple icon="pi pi-plus" label="Ajouter"
                            class="p-button-success"
                            (click)="nouveauRapportSST()"></button>
                        <button pButton class="p-button-outlined"
                            icon="pi pi-filter-slash" (click)="clearFilters(dt)"></button>
                    </div>
                    <div class="flex align-items-center flex-wrap gap-3">
                        <p-multiSelect optionLabel="entete" [style]="{minWidth: '200px'}"
                            placeholder="Colonnes..." disabled></p-multiSelect>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="emplacement.emplacementId">
                        <div class="flex justify-content-between align-items-center">
                            Emplacement
                            <p-sortIcon field="emplacement.emplacementId"></p-sortIcon>
                            <p-columnFilter field="emplacement.emplacementId" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="emplacements" placeholder="Any"
                                        (onChange)="filter($event.value)" optionLabel="code" optionValue="emplacementId">
                                        <ng-template let-option pTemplate="selectedItem">
                                            <span class="ml-1">{{option.code}}</span>
                                            <span class="ml-1">{{option.nom}}</span>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="date">
                        <div class="flex justify-content-between align-items-center">
                            Date
                            <p-sortIcon field="date"></p-sortIcon>
                            <p-columnFilter type="date" field="date" dateFormat="dd/mm/yyyy" display="menu" class="ml-auto" />
                        </div>
                    </th>
                    <th pSortableColumn="statut.statutId">
                        <div class="flex justify-content-between align-items-center">
                            Statut
                            <p-sortIcon field="statut.statutId"></p-sortIcon>
                            <p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
                                        (onChange)="filter($event.value)" optionValue="statutId">
                                        <ng-template let-option pTemplate="item">
                                            <div class="multiselect-representative-option">
                                                <span class="ml-1">{{option.nom}}</span>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="selectedItem">
                                            <div *ngIf="statut">
                                                {{statut.nom}}
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="employe.nom">
                        <div class="flex justify-content-between align-items-center">
                            Employé
                            <p-sortIcon field="employe.nom"></p-sortIcon>
                            <p-columnFilter type="text" field="employe.nom" display="menu" class="ml-auto" />
                        </div>
                    </th>
                    <th pSortableColumn="nbLines">
                        <div class="flex justify-content-between align-items-center">
                            Lignes
                            <p-sortIcon field="nbLines"></p-sortIcon>
                            <p-columnFilter type="numeric" field="nbLines" display="menu" class="ml-auto" />
                        </div>
                    </th>
                    <th pSortableColumn="nbDocuments">
                        <div class="flex justify-content-between align-items-center">
                            Documents
                            <p-sortIcon field="nbDocuments"></p-sortIcon>
                            <p-columnFilter type="numeric" field="nbDocuments" display="menu" class="ml-auto" />
                        </div>
                    </th>	
                    <th class="text-right">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rapportSST>
                <tr>
                    <td>
                        <div class="flex flex-wrap justify-content-between flex-grow-1 gap-3">
                            <h6 *ngIf="appMain.isMobile" class="p-column-title">Emplacement</h6>
                            <span>{{rapportSST.emplacement.code}} - {{rapportSST.emplacement.nom}}</span>
                        </div>
                    </td>
                    <td><span class="p-column-title">Date</span>{{rapportSST.date | date: 'dd/MM/yyyy'}}</td>
                    <td><span class="p-column-title">Statut</span>
                        <span [class]="'statut ' + rapportSST.statut.nom.toLowerCase()">
                            {{rapportSST.statut.nom}}
                        </span>
                    </td>
                    <td><span class="p-column-title">Employé</span><app-employe-avec-emplacement [employe]="rapportSST.employe"></app-employe-avec-emplacement></td>
                    <td><span class="p-column-title">Lignes</span>{{rapportSST.nbLines || "Vide"}}</td>
                    <td><span class="p-column-title">Documents</span>{{rapportSST.nbDocuments || "Aucun"}}</td>
                    <td>
                        <div class="flex justify-content-end">
                            <p-button pRipple icon="pi pi-eye" severity="success" size="small" [label]="appMain.isMobile ? 'Voir' : ''"
                            [routerLink]="['/assurancequalite/rapportjournalier/' + rapportSST.rapportSstId]"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
                <tr>
                    <td colspan="9" class="text-center">
                        <p-progressSpinner></p-progressSpinner>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingicon"></ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td *ngIf="!error && totalRecords === 0" colspan="9" class="text-center py-6">
                        <div class="flex flex-column align-items-center gap-3">
                            <i class="pi pi-file-edit" style="font-size: 3rem; color: #6c757d;"></i>
                            <div class="flex flex-column align-items-center gap-2">
                                <h4 class="m-0" style="color: #495057;">Aucun rapport journalier SST</h4>
                                <p class="m-0" style="color: #6c757d;">Commencez par créer votre premier rapport journalier SST</p>
                            </div>
                            <button pButton pRipple icon="pi pi-plus" label="Créer le premier rapport"
                                class="p-button-success p-button-lg"
                                (click)="nouveauRapportSST()"></button>
                        </div>
                    </td>
                    <td *ngIf="!error && totalRecords > 0" colspan="9" class="text-center py-6">
                        <i class="pi pi-fw pi-info-circle"></i>
                        <span class="ml-2">Aucun rapport journalier SST trouvé</span>
                    </td>
                    <td *ngIf="error" colspan="9" class="text-center py-6" style="color: red;">
                        <i class="pi pi-fw pi-info-circle"></i>
                        <span class="ml-2">Erreur: {{error}}</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-card>
</div>

<div [ngClass]="{'hidden': selectedView() !== 'calendar'}">
    <app-rapport-journalier-sst-calendar></app-rapport-journalier-sst-calendar>
</div>

<style>
    .hidden {
        display: none;
    }
</style>